<template>
  <div class="pop" :style="buttonStyle">
    <div class="bg-in">
      <img
        class="bg"
        :src="bg"
       alt="">
      <div class="button" @click="goToPromotion"/>
      <div class="cancel-btn" @click="close">
        <img :src="cancelWhite" alt="cancel">
      </div>
    </div>
  </div>
</template>

<script>
import bg from '@/assets/images/sportsBetting/2025IplPop.webp'
import cancelWhite from '@/assets/images/sportsBetting/closePop.svg'
import {closePop} from '@/utils'

export default {
  name: 'RegularlyActivityPop',
  props: ['handleClose'],
  data () {
    return {
      bg,
      cancelWhite,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      delayedAWhile: false
    }
  },
  watch: {
  },
  computed: {
    buttonStyle () {
      // 如果是苹果手机，则添加 margin-bottom: 14vw
      return this.isAppleDevice() ? {paddingBottom: '30vw'} : {}
    }
  },
  mounted () {
  },
  methods: {
    isAppleDevice () {
      const userAgent = navigator.userAgent.toLowerCase()
      // 判断是否为苹果设备
      return /iphone|ipod|ipad/.test(userAgent)
    },
    close () {
      this.handleClose()
    },
    goToPromotion () {
      closePop(3) // 关闭弹窗并且不弹出其他弹窗
      if (this.userInfo) {
        this.$router.push('/sportsBetting')
      } else {
        // this.$store.commit('setLoginPopShow', true)
        this.$router.push('/Login')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .pop {
    position: fixed;
    top: 0;
    left: 0;
    height:100vh;
    width: 100vw;
    background-color: rgba(0,0,0,.6);
    z-index: 9;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;

    .bg-in {
      width: 100%;
      height: max-content;

      .bg {
        width: 100vw;
        height: auto;
      }

      .cancel-btn {
        position: absolute;
        top: 178vw;
        left: 50%;
        transform: translate(-50%);
        width: 6vw;
        height: 6vw;
      }

      .button {
        position: absolute;
        top: 156.5vw;
        left: 50%;
        transform: translate(-50%);
        width: 88vw;
        height: 12.5vw;
      }
    }
  }

  .pop::-webkit-scrollbar {
    display: none
  }
</style>



// WEBPACK FOOTER //
// src/components/RegularlyActivityPop/index.vue